import { TabBar as CssModulesTabBar, TabBarProps } from '@sunwebgroup/uds-ui/tab-bar'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/tab-bar' instead.
 */
export default Object.assign(
  styled(CssModulesTabBar)<TabBarProps>``,
  { displayName: 'TabBar', Tab: CssModulesTabBar.Tab },
)
